import { SupplierIconFieldsFragment } from "@/gql/graphql";
import { ImoovaImage } from "@/app/Media/Components/Image";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

export function SupplierIcon({
  model,
  className,
  fallback = null,
}: {
  model: SupplierIconFieldsFragment;
  className?: string;
  fallback?: ReactNode;
}) {
  const media = model.icon ?? model.logo;

  if (!media) {
    return fallback;
  }

  return (
    <ImoovaImage
      media={media}
      alt={model.name}
      className={cn("object-contain", className)}
    />
  );
}
